module.exports = __webpack_public_path__ + "static/media/restaurant.4a6f3585.png";